import { type ReactElement } from 'react'

import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import {
  LARGE_TILE_GRID_CLASSNAME,
  LARGE_TILE_HEIGHT_PX,
  QUICK_ACCESS_SECTION_CLASSNAME,
  SMALL_TILE_GRID_CLASSNAME,
  SMALL_TILE_HEIGHT_PX,
  TILE_RADIUS,
} from './quick-access.constants.ts'

export function QuickAccessSkeleton(): ReactElement {
  return (
    <div className={QUICK_ACCESS_SECTION_CLASSNAME}>
      <div className={LARGE_TILE_GRID_CLASSNAME}>
        <Skeleton variant="block" height={LARGE_TILE_HEIGHT_PX} radius={TILE_RADIUS} />
        <Skeleton variant="block" height={LARGE_TILE_HEIGHT_PX} radius={TILE_RADIUS} />
      </div>
      <div className={SMALL_TILE_GRID_CLASSNAME}>
        <Skeleton variant="block" height={SMALL_TILE_HEIGHT_PX} radius={TILE_RADIUS} />
        <Skeleton variant="block" height={SMALL_TILE_HEIGHT_PX} radius={TILE_RADIUS} />
        <Skeleton variant="block" height={SMALL_TILE_HEIGHT_PX} radius={TILE_RADIUS} />
        <Skeleton variant="block" height={SMALL_TILE_HEIGHT_PX} radius={TILE_RADIUS} />
      </div>
    </div>
  )
}
